module.exports = require("@splunk/themes");